import { sendRequest } from "../sendRequest";

export const getRecentTxns = () => {
  const queryKey = ["wallet", "txns"];
  const queryFunction = ({ pageParam }) =>
    sendRequest(
      "get",
      `/influencer/wallet/recent/tnx?limit=20${
        pageParam ? `&nextPageToken=${pageParam}` : ""
      }`
    ).then((res) => res.data);
  return { queryKey, queryFunction };
};
